import { z } from "zod";

// EHR appointment/slot IDs are opaque: numeric for some EHRs (e.g. Athena),
// alphanumeric/hex for others (e.g. Cobalt). Accept any non-empty token of
// alphanumerics plus the usual ID separators; coerce numbers the LLM may pass.
export const normalizedEhrIdSchema = z.coerce.string().regex(/^[A-Za-z0-9_-]+$/, "ID must be alphanumeric");

export const versionedAppointmentActionIdSchema = z
  .string()
  .regex(
    /^appt\.v1\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/,
    "Appointment action ID must be a valid version 1 reference"
  );

export const versionedAppointmentSlotActionIdSchema = z
  .string()
  .regex(
    /^slot\.v1\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/,
    "Appointment slot action ID must be a valid version 1 reference"
  );

/** A signed v1 action reference or an unqualified legacy backend identifier. */
export const appointmentActionIdSchema = z.union([
  versionedAppointmentActionIdSchema,
  z.preprocess(
    (value) => (typeof value === "number" ? String(value) : value),
    z.string().regex(/^[A-Za-z0-9_-]+$/, "ID must be alphanumeric")
  ),
]);
